module.exports = __webpack_public_path__ + "static/img/qc-B-0o_1QI.d4808f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/qc-B-0o_1QI.png
// module id = xiYu
// module chunks = 16